import React from "react";
import { UseFormRegister } from "react-hook-form";
import Label from "components/shared/form/Label";
import Hint from "components/shared/fields/Hint";
import useRegisterPropOrFromContext from "components/shared/form/fields/useRegisterPropOrFromContext";
import classNames from "classnames";

type InputArgs = {
  name: string;
  register?: UseFormRegister<any>;
  label?: string;
  hint?: string;
  required?: string | boolean;
  placeholder?: string;
  multiline?: boolean;
  maxLength?: number;
  disabled?: boolean;
  ariaLabel?: string;
  type?: string;
  rows?: number;
  error?: boolean;
};

export default function TextInput({
  label,
  register,
  name,
  hint,
  placeholder = "",
  required = false,
  multiline = false,
  maxLength,
  disabled = false,
  ariaLabel = label,
  type = "text",
  rows,
  error = false,
}: InputArgs) {
  register = useRegisterPropOrFromContext(register);

  return (
    <div className="control-group">
      {label && <Label label={label} required={!!required} />}
      <div className="controls">
        {multiline ? (
          <textarea
            {...register(name, { required })}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            rows={rows}
            aria-label={ariaLabel}
            className={classNames({ "field-error": error })}
          />
        ) : (
          <input
            type={type}
            {...register(name, { required })}
            placeholder={placeholder}
            maxLength={maxLength}
            disabled={disabled}
            aria-label={label}
            className={classNames({ "field-error": error })}
          />
        )}
        {hint && <Hint hint={hint} />}
      </div>
    </div>
  );
}
